module.exports = __webpack_public_path__ + "static/paris-002.thumb-8a3422ce37db0b49d18b89106ceb285c.jpg";